module.exports = __webpack_public_path__ + "assets/img/drills.a26ce629.png";